import { analyticsAnimated } from './analyticsAnimated';
import { arkLoadingSpinner } from './arkLoadingSpinner';
import animation from './animation.json';
import { bookAnimated } from './bookAnimated';
import { documentsLoading } from './documentsLoading';

export enum LottieAntimationTypes {
    ANALYTICS = 'analytics',
    ANIMATION = 'animation',
    ARK_LOADING = 'ark-loading',
    BOOK = 'book',
    DOCUMENTS = 'documents'
}

export const getLottieAnimation = (lottieType: LottieAntimationTypes, isDarkMode = false) => {
    switch (lottieType) {
        case LottieAntimationTypes.ANALYTICS:
            return analyticsAnimated(isDarkMode);
        case LottieAntimationTypes.ARK_LOADING:
            return arkLoadingSpinner(isDarkMode);
        case LottieAntimationTypes.BOOK:
            return bookAnimated(isDarkMode);
        case LottieAntimationTypes.DOCUMENTS:
            return documentsLoading(isDarkMode);
        case LottieAntimationTypes.ANIMATION:
        default:
            // edge case, because this animation does not have dark mode variant
            return animation;
    }
};
